import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import HomePage from './pages/HomePage';
import ResultPage from './pages/ResultPage';
import PreviewPage from './pages/PreviewPage';

// 创建路由器配置
const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF2442',
      light: '#FF6B80',
      dark: '#FF1030',
    },
    secondary: {
      main: '#FFF5F7',
      light: '#FFFFFF',
      dark: '#FFE4E8',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
    background: {
      default: '#FFF5F7',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: "'Noto Sans KR', 'Noto Sans SC', 'Noto Sans', sans-serif",
    h1: {
      fontSize: '24px',
      fontWeight: 700,
    },
    h2: {
      fontSize: '20px',
      fontWeight: 600,
    },
    body1: {
      fontSize: '16px',
    },
    body2: {
      fontSize: '14px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FFF5F7',
          backgroundImage: `
            linear-gradient(#ECECEC 1px, transparent 1px),
            linear-gradient(90deg, #ECECEC 1px, transparent 1px)
          `,
          backgroundSize: '20px 20px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: 'none',
          padding: '12px 24px',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        contained: {
          '&.Mui-disabled': {
            backgroundColor: '#FFB8C4',
            color: '#FFFFFF',
          },
        },
        outlined: {
          borderColor: '#FFE4E8',
          '&:hover': {
            borderColor: '#FF2442',
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#FFE4E8',
            },
            '&:hover fieldset': {
              borderColor: '#FF2442',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#FF2442',
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router {...router}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="/preview" element={<PreviewPage />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
